var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"withdraw",attrs:{"id":"live-start"}},[_c('my-header',{attrs:{"color":"#333"}}),_vm._v(" "),_c('loginhome'),_vm._v(" "),_c('my-footer',{staticStyle:{"clear":"both"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c46ac4a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/loginhome/app.vue
// module id = 731
// module chunks = 12